import { render } from "./IndexFacture.vue?vue&type=template&id=564b7fde"
import script from "./IndexFacture.vue?vue&type=script&lang=js"
export * from "./IndexFacture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__